<script lang=ts>
      import BlockWidth from "../blocks/BlockWidth.svelte"
      import { getLocaleContext } from "../locale/ts/Locale.svelte"
      import Metatags from "../metatags/Metatags.svelte"
      import { getMetaContext } from "../metatags/ts/MetaContext.svelte"
      import ProgramList from "./ProgramList.svelte"

  const locale = getLocaleContext()
  let { items } = $props()
  const meta = getMetaContext()

  meta.setMeta({
    title: "Program"
  })

</script>

<BlockWidth width="wide">
  <ProgramList items={items}></ProgramList>
</BlockWidth>

<style lang=postcss>
  
</style>
